import React, { useCallback } from 'react';
import { Button } from 'devextreme-react/button';
import style from './zdvllineicon.module.scss';

const ZDVLLineIcon = ({
  data,
  setZDVLLineStatusData
}) => {
  const onClickIcon = useCallback(() => {
    const temp = {
      updateCase: null,
      item: [data.data]
    };
    if ((data.data.taskNumber === null
        && data.data.capacityAccepted === 0
        && data.data.capacityEndProduct === 0)
      || data.data.lineStatus === 5) {
      temp.updateCase = 1; // 1
    } else if (data.data.lineStatus === 6
      && data.data.capacityAccepted === 0
      && data.data.capacityEndProduct === 0) {
      temp.updateCase = 2; // 2.1
    } else if (data.data.lineStatus === 6
      && data.data.capacityAccepted === 0) {
      temp.updateCase = 3; // 2.2
    } else {
      temp.updateCase = 4; // 2.3
    }
    setZDVLLineStatusData(temp);
  }, [data, setZDVLLineStatusData]);

  return (
    <>
      <Button type="default"
              elementAttr={{ class: style.zdvllinestatus }}
              stylingMode="text"
              onClick={onClickIcon}
              icon={
                (window.localStorage.getItem('theme')
                && window.localStorage.getItem('theme') === 'material.blue.dark'
                  ? '/images/zdvl-changed-button-dark.svg'
                  : '/images/zdvl-changed-button.svg')
              }
      />
      <span>{data.value}</span>
    </>
  );
};
  // ), [data.value, onClickIcon]);

export default React.memo(ZDVLLineIcon);
